// material-ui
import LinearProgress from '@mui/material/LinearProgress';
import { styled, useTheme } from '@mui/material/styles';
import React, { useEffect, useMemo, useState } from 'react';
import { CircularProgress, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';

export const FetchDataLoader = ({ text = 'Fetching Data' }) => {
  const theme = useTheme();
  const [fetchingText, setFetchingText] = useState(text);
  const texts = useMemo(() => [`${text}`, `${text}.`, `${text}..`, `${text}...`], [text]);
  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % texts.length;
      setFetchingText(texts[index]);
    }, 500); // Change text every 500ms

    return () => clearInterval(interval);
  }, [texts]);
  return (
    <Grid
      container
      spacing={2}
      sx={{
        alignItems: 'center'
      }}
    >
      <Grid>
        <CircularProgress aria-label="progress" size={30} />
      </Grid>
      <Grid>
        <Typography variant="subtitle1" color={theme.palette.primary.main}>
          {fetchingText}
        </Typography>
      </Grid>
    </Grid>
  );
};

FetchDataLoader.propTypes = {
  text: PropTypes.string
};

// styles
const LoaderWrapper = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 1301,
  width: '100%'
});

// ==============================|| LOADER ||============================== //

const Loader = () => (
  <LoaderWrapper>
    <LinearProgress color="primary" />
  </LoaderWrapper>
);

export default Loader;
